import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.ANALYTICS_API;

const userAndOrganizationActivityAnalyticService = {
  async getUserAndOrganizationStats() {
    const sessionToken = await getSessionToken();

    const getUserAndOrganizationStatsOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'user_org_stats',
        },
      },
    });

    const getUserAndOrganizationStatsResults = (
      await getUserAndOrganizationStatsOperation.response
    ).body.json();

    return getUserAndOrganizationStatsResults;
  },

  async getUserRoleBreakdown() {
    const sessionToken = await getSessionToken();

    const getUserRoleBreakdownOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'user_role_breakdown',
        },
      },
    });

    const getUserRoleBreakdownResults = (
      await getUserRoleBreakdownOperation.response
    ).body.json();

    return getUserRoleBreakdownResults;
  },

  async getUserRegistrationAnalytics() {
    const sessionToken = await getSessionToken();

    const getUserRegistrationAnalyticsOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'registered_users_count',
        },
      },
    });

    const getUserRegistrationAnalyticsResults = (
      await getUserRegistrationAnalyticsOperation.response
    ).body.json();

    return getUserRegistrationAnalyticsResults;
  },

  async getActiveUsersAnalytics() {
    const sessionToken = await getSessionToken();

    const getActiveUsersAnalyticsOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'active_users',
          period: 'all',
        },
      },
    });

    const getActiveUsersAnalyticsResults = (
      await getActiveUsersAnalyticsOperation.response
    ).body.json();

    return getActiveUsersAnalyticsResults;
  },

  async getInvitedUserStats() {
    const sessionToken = await getSessionToken();

    const getInvitedUserStatsOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'invited_users_stats',
        },
      },
    });

    const getInvitedUserStatsResults = (
      await getInvitedUserStatsOperation.response
    ).body.json();

    return getInvitedUserStatsResults;
  },

  async getActivePrescribers({ period = '30d' }) {
    const sessionToken = await getSessionToken();

    const getActivePrescribersOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'active_prescribers',
          period: period,
        },
      },
    });

    const getActivePrescribersResults = (
      await getActivePrescribersOperation.response
    ).body.json();

    return getActivePrescribersResults;
  },

  async getCoverageSearchesPerPrescriberPerWeek({ weeks = 4 }) {
    const sessionToken = await getSessionToken();

    const getCoverageSearchesPerPrescriberPerWeekOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'coverage_searches_per_prescriber_per_week',
          weeks: weeks,
        },
      },
    });

    const getCoverageSearchesPerPrescriberPerWeekResults = (
      await getCoverageSearchesPerPrescriberPerWeekOperation.response
    ).body.json();

    return getCoverageSearchesPerPrescriberPerWeekResults;
  },

  async getDAUMAUCalculation({ days = 30 }) {
    const sessionToken = await getSessionToken();

    const getDAUMAUCalculationOperation = post({
      apiName: apiNamePath,
      path: '/user_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'dau_mau_calculation',
          days: days,
        },
      },
    });

    const getDAUMAUCalculationResults = (
      await getDAUMAUCalculationOperation.response
    ).body.json();

    return getDAUMAUCalculationResults;
  },
};

export default userAndOrganizationActivityAnalyticService;
